import { Fragment, useState } from 'react';
import { useForm } from 'react-hook-form';
import { translate } from 'react-switch-lang';
import { Alert, Button, FormGroup, Modal, ModalBody, ModalHeader } from 'reactstrap';
import SweetAlert from 'sweetalert2';
import { useHttpClient } from '../../../../../../security/hooks/axiosProvider';
import styles from '../../../../styles/style-setting.module.scss';

const CreateActivity = (props) => {
  const httpClient = useHttpClient(true);
  const {
    register,
    handleSubmit,
    resetField,
    formState: { errors },
  } = useForm();
  const [Open, setOpen] = useState(false);
  const [CreateModal, setCreateModal] = useState(false);
  const CreateModalToggle = () => resetForm();
  const Toggle = () => setOpen(!Open);
  const [spinner, setSpinner] = useState(false);

  const onSubmit = async (data) => {
    const activityData = { name: data['activity_name'] };
    try {
      setSpinner(true);
      const response = httpClient.current?.post(`/api/activity`, activityData);
      if ((await response).status === 200) {
        setSpinner(false);
        props.activities();
        resetForm();
      }
    } catch (error) {
      SweetAlert.fire({
        icon: 'error',
        title: 'Ouuups ...',
        text: props.t('err'),
      });
    }
  };

  const resetForm = () => {
    resetField('activity_name');
    setCreateModal(!CreateModal);
  };

  return (
    <>
      <Button outline color="success" onClick={CreateModalToggle}>
        {' '}
        {props.t('create_activity')}
      </Button>
      <Modal isOpen={CreateModal} toggle={CreateModalToggle} centered>
        <ModalHeader toggle={CreateModalToggle}>{props.t('create_activity')}</ModalHeader>
        <ModalBody>
          <Fragment>
            <Alert className="alert-dismissible" color="success dark" isOpen={Open} target="Alert">
              <strong>{props.t('great')}</strong>
              <Button className="close" color="default" id="Alert" onClick={Toggle}>
                <span>×</span>
              </Button>
            </Alert>
            {spinner === true ? (
              <div className="loader-box">
                <div className="loader-3"></div>
              </div>
            ) : (
              <form className="needs-validation" noValidate onSubmit={handleSubmit(onSubmit)}>
                <FormGroup className="form-row">
                  <input
                    type="text"
                    className="form-control"
                    name="activity_name"
                    id="activity_name"
                    aria-invalid={errors.activity_name ? 'true' : 'false'}
                    placeholder={props.t('placeholder_activity_name')}
                    {...register('activity_name', { required: true })}
                  />
                  <span>{errors.activity_name && <p>{props.t('errors_champ')}</p>}</span>
                </FormGroup>

                <Button outline color="success" className="float-right" type="submit">
                  {props.t('save')}
                </Button>
                <Button className={styles['btn-cancel']} onClick={resetForm}>
                  {props.t('cancel')}
                </Button>
              </form>
            )}
          </Fragment>
        </ModalBody>
      </Modal>
    </>
  );
};

export default translate(CreateActivity);
